import React, { useState, useEffect } from "react";

import "./styles.scss";
import { Resource } from 'app/api/types';
import { v4 as uuidv4 } from 'uuid';

interface IProps {
  onSubmit: (data: Resource, file: File, preview?: File) => void;
  onSuccessChange: (active: boolean) => void;
  isSubmit: boolean;
}

const AddResource: React.FC<IProps> = ({
  onSubmit,
  onSuccessChange,
  isSubmit
}) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null as File | null);
  const [preview, setPreview] = useState(null as File | null);

  const onChange = (e: any) => {
    e.target.name === "title" && setTitle(e.target.value);
    e.target.name === "description" && setDescription(e.target.value);
    e.target.name === "file" && setFile(e.target.files[0]);
    e.target.name === "preview" && setPreview(e.target.files[0]);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    onSubmit({
      id: uuidv4(),
      name: title,
      description: description,
      type: '',
      previewUrl: '',
      fullUrl: '',
      lowUrl: ''
    }, file as File, (preview ?? undefined) as File | undefined);
  };

  const getHeight = () => {
    let height = 50;
    if (title.length > 1) height += 47;
    if (description.length > 1) height += 52;
    if (file) {
      if (file.type.includes('image')) {
        height += 20;
      } else {
        height += 60;
      }
    }

    return height;
  };

  useEffect(() => {
    if (
      title.length > 1 &&
      description.length > 1 &&
      file
    )
      onSuccessChange(true);
    else onSuccessChange(false);

    isSubmit &&
      onSubmit({
        id: uuidv4(),
        name: title,
        description: description,
        type: '',
        previewUrl: '',
        fullUrl: '',
        lowUrl: ''
      }, file as File, (preview ?? undefined) as File | undefined);
  }, [
    title,
    description,
    file,
    preview,
    onSuccessChange,
    onSubmit,
    isSubmit
  ]);

  return (
    <div className="add-phrase-album" style={{ height: `${getHeight()}px` }}>
      <form className="add-phrase__form" onSubmit={handleSubmit}>
        <input
          className="add-phrase__input"
          onChange={onChange}
          value={title}
          name="title"
          placeholder="Название"
          autoComplete="off"
          required
        />
        {title.length > 1 && (
          <input
            className={`add-phrase__input`}
            onChange={onChange}
            value={description}
            name="description"
            placeholder="описание"
            autoComplete="off"
            required
          />
        )}
        {description.length > 1 && (
            <input
                className={`add-phrase__input`}
                type="file"
                onChange={onChange}
                accept=".png,.jpg,.jpeg,.gif,.mp4,.mov,.avi,.3gp"
                name="file"
                placeholder="файл"
                required
            />
        )}
        {file && !file?.type.includes('image') && (
            <label style={{ marginTop: '10px' }}>
              <span>Изображение для предпросмотра</span>
              <input
                  className={`add-phrase__input`}
                  type="file"
                  onChange={onChange}
                  accept=".png,.jpg,.jpeg,.gif"
                  name="preview"
                  placeholder="превью"
              />
            </label>
        )}
      </form>
    </div>
  );
};

export default AddResource;
